import * as React from 'react';

import ProposedIncomeSplitContainer from '../../../../roadmap/components/go/income-split/ProposedIncomeSplitContainer';

export default function GoIncomeSplitScreen() {
    return <ProposedIncomeSplitContainer />;
}
